export const EVENTS_PER_PAGE = 10;

export const BOOKINGS_PER_PAGE = 10;

export const DEBOUNCE_DELAY = 500;